import style from './HoverBlock.module.scss'
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSearch } from '../../../../redux/headerSlices/HeaderSlices';
import React from 'react';

type HoverContent = {
    id: number;
    rating: number;
    mpa_rating: number;
    runtime: number;
    genres: string[];
}


let HoverBlock: React.FC<HoverContent> = ({ id, rating, mpa_rating, runtime, genres }) => {

    const dispatch = useDispatch()

    return (<>
        <NavLink to={`/movieDetails/${id}`} onClick={e => dispatch(setSearch(''))}><div className={style.hover__block}>
            <div className={style.block__rating} >{rating} / 10</div>
            <div className={style.block__pg}>{mpa_rating}</div>
            <div className={style.block__time}>{runtime} minutes</div>
            <div className={style.block__genres}>{genres.map((el: string) => <span>• {el}</span>)}</div>
        </div></NavLink>
    </>
    )
}

export default HoverBlock